export const defaultFooterProps = {
  "items-per-page-options": [10, 20, 50, 100]
};
